import {parseReference} from '@apps-common/geocorn-sdk/api/util.js';

// In these utilities, we often just look at the last 7 chars to extract the last hashid
const HASHID_LENGTH = 7;

export const getHashFromId = id => {
  if (!id) {
    return '';
  }

  return id.slice(-HASHID_LENGTH);
};

export const getCollectionIDFromReference = ref => {
  if (!ref) {
    return '';
  }
  const parsedRef = parseReference(ref);
  return getHashFromId(parsedRef.collectionId);
};

// we can evaluate whther refs are equal by just comparing the hashid
export const refEquals = (ref1, ref2) => {
  if (!ref1 || !ref2) {
    return false;
  }
  const parsedRef1 = parseReference(ref1);
  const parsedRef2 = parseReference(ref2);
  if (
    (parsedRef1.featureId && !parsedRef2.featureId) ||
    (!parsedRef1.featureId && parsedRef2.featureId)
  ) {
    return false;
  }
  return ref1.slice(-HASHID_LENGTH) === ref2.slice(-HASHID_LENGTH);
};
